import React from "react";
import resetPasswordFunctional from "./index.function";
import AuthWrapper from "../../components/AuthWrapper";
import ViewItems from "../../components/ViewItems";
import Text from "../../components/Text";
import CustomInput from "../../components/CustomInput";
import Button from "../../components/Button";
import ErrorText from "../../components/ErrorText";
import { Formik } from "formik";
import { fontSizes } from "../../constants/constants";
import {
  reset_password_schema,
  reset_password_validation_schema,
} from "../../validations_schemas/reset_password_validation_schema";
import images from "../../constants/images";
import { ReactSVG } from "react-svg";
import icons from "../../constants/icons";
import { cn } from "../../utils/utils";

const ResetPassword = () => {
  const { TextWeight, isArabic, getContentKey, handleResetPassword, authLoading, navigate } =
    resetPasswordFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? "rotate-180" : "")} onClick={() => navigate(-1)} />
        <img src={images.textLogo} width={70} className={cn('mt-10', isArabic ? 'self-end' : 'self-start')} />
        <Formik
          validationSchema={reset_password_validation_schema}
          initialValues={reset_password_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => handleResetPassword(values)}
          className="w-full"
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {
            return (
              <ViewItems className={'w-full'}>
                <Text
                  text={getContentKey("reset_password")}
                  weight={TextWeight.semiBold}
                  size={fontSizes.h18}
                  className={"mb-3 mt-10"}
                />
                <CustomInput
                  label={getContentKey("password")}
                  placeholder={'***********'}
                  divClasses={"mt-2"}
                  isRequired
                  isRounded
                  value={values?.password}
                  onChange={(e) => setFieldValue("password", e.target.value)}
                  isError={errors?.password}
                  isPassword={true}
                />
                <ErrorText
                  text={errors?.password}
                  getContentKey={getContentKey}
                />

                <CustomInput
                  label={getContentKey("confirm_password")}
                  placeholder={'***********'}
                  isRequired
                  isRounded
                  divClasses={"mt-4"}
                  value={values?.confirm_password}
                  onChange={(e) => setFieldValue("confirm_password", e.target.value)}
                  isError={errors?.confirm_password}
                  isPassword={true}
                />

                <ErrorText
                  text={errors?.confirm_password}
                  getContentKey={getContentKey}
                />

                <Button
                  text={getContentKey("submit")}
                  className={"mt-6 my-2 w-full"}
                  onClick={handleSubmit}
                  loading={authLoading}
                />
              </ViewItems>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ResetPassword;
